
window.addEventListener("scroll", () => {
  const nav = document.getElementById("navbar");
  nav.classList.toggle("scrolled", window.scrollY > 50);
});



$(document).ready(function(){
  $(".menu-toggle-icon").click(function(){
    $("body").toggleClass("toggle-open");
  });
});

class ReadMore {
  constructor(box) {
    this.box = box;
    this.button = box.querySelector(".read-more-btn");

    this.button.addEventListener("click", () => {
      this.toggleText();
    });
  }

  toggleText() {
    this.box.classList.toggle("active");

    if (this.box.classList.contains("active")) {
      this.button.innerText = "Read Less";
    } else {
      this.button.innerText = "Read More";
    }
  }
}

// Multiple components ke liye
document.querySelectorAll(".read-more-box").forEach(box => {
  new ReadMore(box);
});




const tabs = document.querySelectorAll('[data-tab-target]')
const tabContents = document.querySelectorAll('[data-tab-content]')

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})


   jQuery('.primary-menu ul li').each(function() {
    jQuery(this).children('ul').before('<span class="sub"><i class="fa fa-angle-down" aria-hidden="true"></i><i class="fa fa-angle-up" aria-hidden="true"></i></span>');
  });
  jQuery('.primary-menu ul li .sub').click(function(e) {
    jQuery(this).next('ul').slideToggle();
    jQuery(this).toggleClass('submenu-hide');
  });




    $(document).ready(function(){
             $('#lightgallery').lightGallery();
         });

 $('#hero').owlCarousel({
      animateOut: 'fadeOut',
      items:1,
      loop:true,
      autoplayHoverPause: false,
      autoplay: true,
      smartSpeed: 1000,
    })



 $('#service').owlCarousel({
      animateOut: 'fadeOut',
      margin:0,
      items:1,
      loop:false,
      nav: true,
      dots: false,
      autoplayHoverPause: false,
      autoplay: false,
      smartSpeed: 1000,
       responsive: {
                      0: {
                        items: 1
                      },
                      600: {
                        items: 1
                      },
                      768: {
                        items: 2
                      },
                       991: {
                        items: 3
                      },
                      1200: {
                        items: 1
                    }
    }
    })






if ($(window).width() > 1200) {
   wow = new WOW(
      {
        animateClass: 'animated',
        offset:       100,
        callback:     function(box) {
          console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
        }
      }
    );
    wow.init();
    document.getElementById('moar').onclick = function() {
      var section = document.createElement('section');
      section.className = 'section--purple wow fadeInDown';
      this.parentNode.insertBefore(section, this);
    };
}
